import React, { useCallback, useState } from "react";
import {
  ChoiceList,
  DisplayText,
  TextField,
  TextStyle,
} from "@shopify/polaris";
import step0 from "../../assets/poll.png";

const Step0 = (props) => {
  const [feedback, setfeedback] = useState("");
  const [description, setdescription] = useState("");
  const [selected, setSelected] = useState("");
  const changePoll = (value) => {
    setSelected(value);
    props.changePoll({ type: value[0], note: "" });
  };

  const handleTextFieldChange = useCallback((value) => {
    setdescription(value);
    props.changePoll({ type: selected[0], note: value });
  });

  const renderChildren = useCallback(
    (isSelected) =>
      isSelected && (
        <TextField
          label={
            selected[0] == "blogs"
              ? "Which blog did you visit?"
              : selected[0] == "youtube"
              ? "Which youtube channel?"
              : "Please specify"
          }
          onChange={handleTextFieldChange}
          value={description}
          autoComplete="off"
        />
      ),
    [handleTextFieldChange, description]
  );

  return (
    <div className="tab-pane">
      <div className="text-center">
        <img style={{ width: "60%" }} src={step0} alt="Responsive image" />
      </div>
      <div className="panel-heading pb-4 text-center">
        <DisplayText size="medium">How did you discover Synctrack?</DisplayText>
      </div>

      <div className="panel-body">
        <div className="text-center">
          <div className="mt-3 text-left">
            <ChoiceList
              choices={[
                { label: "Youtube", value: "youtube", renderChildren },
                {
                  label: "Recommended by friend or colleague",
                  value: "friend_colleague",

                  renderChildren,
                },
                {
                  label: "Search Engine (Shopify, Google, Yahoo, etc)",
                  value: "search_engine",
                  renderChildren,
                },
                { label: "Blogs", value: "blogs", renderChildren },
              ]}
              selected={selected}
              onChange={changePoll}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Step0;
